/** sessionStorage: imagen en base64 (sin prefijo data:) para SRP de búsqueda visual */
export const VISUAL_SEARCH_IMAGE_SESSION_KEY =
    'casaideas_pwa_visual_search_image_b64'

/** sessionStorage: etiqueta COCO (inglés) del objeto detectado por MediaPipe */
export const VISUAL_SEARCH_OBJECT_LABEL_SESSION_KEY =
    'casaideas_pwa_visual_search_object_label'

/** Query param para forzar nueva navegación al repetir búsqueda visual en la SRP */
export const VISUAL_SEARCH_REQUEST_QUERY_KEY = 'vs'

export type VisualSearchResultMode = 'visual' | 'object_type' | 'none'

/** Limpia imagen/label de visual search (p. ej. al pasar a productSearch por texto). */
export const clearVisualSearchSession = (): void => {
    if (typeof window === 'undefined') return
    try {
        sessionStorage.removeItem(VISUAL_SEARCH_IMAGE_SESSION_KEY)
        sessionStorage.removeItem(VISUAL_SEARCH_OBJECT_LABEL_SESSION_KEY)
    } catch {
        // sessionStorage puede fallar en modo privado / políticas del browser
    }
}

export const isVisualSearchQuery = (
    visualSearchParam: string | string[] | undefined
): boolean =>
    visualSearchParam === '1' || visualSearchParam === 'true'
